var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-tree-demo"}},[_c('tree-dropdown'),_c('tree-search-tree'),_c('tree-async-tree')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }